import { render, staticRenderFns } from "./FSFooter.vue?vue&type=template&id=6c11c126&scoped=true&"
import script from "./FSFooter.vue?vue&type=script&lang=js&"
export * from "./FSFooter.vue?vue&type=script&lang=js&"
import style0 from "./FSFooter.vue?vue&type=style&index=0&id=6c11c126&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c11c126",
  null
  
)

export default component.exports